export const VERSION = '4.2.2-gogreen';
export const GIT_HASH = 'e1f43d96ad6c9a8b7d22f9dda5d6b7f62f700904';
export const BUILD_DATE = '';
